"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_DataRequirement_Sort = exports.DataRequirement_SortDirectionKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var DataRequirement_SortDirectionKind;
(function (DataRequirement_SortDirectionKind) {
    DataRequirement_SortDirectionKind["_ascending"] = "ascending";
    DataRequirement_SortDirectionKind["_descending"] = "descending";
})(DataRequirement_SortDirectionKind = exports.DataRequirement_SortDirectionKind || (exports.DataRequirement_SortDirectionKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_DataRequirement_Sort = t.recursion('IDataRequirement_Sort', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        path: t.string,
        _path: RTTI_Element_1.RTTI_Element,
        direction: (0, EnumType_1.createEnumType)(DataRequirement_SortDirectionKind, 'DataRequirement_SortDirectionKind'),
        _direction: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_DataRequirement_Sort.js.map